<script setup>
/**
 * Renders a `freeform` block — a bespoke, custom-authored section whose markup is
 * self-contained in `data.html` (content + image src/href inline), sanitized
 * server-side. The public SSG output is therefore complete and SEO-ready with
 * no client-side injection.
 *
 * In builder edit mode the `[data-edit]` / `[data-edit-img]` / `[data-edit-link]`
 * regions become inline-editable, wired by `useFreeformEditable`. The
 * surrounding `EditableBlock` provides block-level select/hover.
 */
import { ref, computed } from "vue";
import { useFreeformEditable } from "~/composables/useFreeformEditable";

const props = defineProps({ data: { type: Object, required: true } });

const root = ref(null);
useFreeformEditable(root, computed(() => props.data.fields), computed(() => props.data.html));
</script>

<template>
  <div ref="root" class="hk-freeform" v-html="data.html" />
</template>
